import React, { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import { Alert, HeaderModal, Loading, Toast } from "../../../components";
import { cameraManagement } from "../../../services/api/cameraManagementApi";
import styles from "./Camera.module.css";
import { useStoreContext } from "../../../hooks/useStoreContext";
import Setting from "./Setting/Setting";
import { recordApi } from "../../../services/api/RecordApi";
import SideBar from "./Setting/SideBar";
import axiosClient from "../../../services/axiosClient";
import { actions } from "../../../store";
import { serviceApi } from "../../../services/api/servicesApi";
import { aiConfigService } from "../../../services/api/aiConfigService";
import { useTranslation } from "react-i18next";
import { listAiTranslate } from "../../../utils";
const cx = classNames.bind(styles);
const ModalSetting = ({
  camera,
  onclose,
  setIsRefresh,
  isRefresh,
  show,
  fullScreen,
  setIsSetting
}) => {
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const [isLoseConnect, setIsLoseConnect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [changeConfigRecord, setChangeConfigRecord] = useState(false);
  const [listServiceAI, setListServiceAI] = useState([]);
  const refModal = useRef(null);
  const [typeCamera, setTypeCamera] = useState("");
  const [type, setType] = useState("2");
  const { t } = useTranslation();
  const [count, setCount] = useState(false);

 
  const handleClose = () => {
    onclose();
  };
  const onChangeType = (data) => {
    setType(data);
  };
  const record = async (boolean, data) => {
    setIsLoading(true);
    try {
      const record = {
        camera_code: camera[0].CODE,
        status_record: boolean ? "1" : "0",
      };
      const res = await recordApi.changeStatus(record);
      if (boolean) {
        Toast.open(t("settingCam.Enable_recording_successfully"), "success");
      } else {
        Toast.open(
          t("cameraManager.Turn_off_recording_successfully"),
          "success"
        );
      }
      setChangeConfigRecord(!changeConfigRecord);
      setIsLoading(false);
      return res;
    } catch (e) {
      setIsLoading(false);
      if (e.response.status === 500) {
        Toast.open(t("settingCam.Error_from_server_side"), "danger");
      } else {
        Toast.open(e.response?.data?.result, "danger");
      }
    }
  };

  const checkTime = (code) => {
    const state = JSON.parse(localStorage.getItem("stateCameraChange"));
    const currentTime = new Date().getTime() / 1000;
    if (code === state?.code) {
      if (currentTime - state.time > 25) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const getListStatus = useCallback(async (code) => {
    try {
      const data = [code];
      const res = await cameraManagement.postStatus({
        list_camera_code: data,
      });
      setIsRefresh(!isRefresh);
      return res.result;
    } catch (e) {}
  }, []);
  // setting streaming
  const onChange = async (setting, refresh, setRefresh) => {
    setIsLoading(true);
    if (!setting.status) {
      try {
        // tat camera
        // console.log(camera);

        const codeCamera = camera[0].CODE;
        if (camera[0].STATUS_ACTIVE !== 3) {
          await cameraManagement.stopStreaming({
            camera_id: codeCamera,
            delete_config_record: 1,
          });
        }

        const res1 = await cameraManagement.update(
          {
            camera_status: "Off",
            // stream_mode: setting.streamMode,
            // source_stream: setting.sourceConfig,
          },
          codeCamera
        );

        handleChangePriorityCamera(codeCamera, 0);
        setIsLoading(false);
        setIsRefresh(!isRefresh);
        if (res1.result) {
          // setIsRefresh(!isRefresh);
          Toast.open(
            t("settingCam.Successfully_turned_off_the_camera"),
            "success"
          );
          const state = JSON.stringify({
            code: codeCamera,
            time: new Date().getTime() / 1000,
          });
          sessionStorage.setItem("stateCameraChange", state);
          setTimeout(() => {
            getListStatus(codeCamera);
          }, 30 * 1000);
          // onclose()
        }
        setCount(true);
        setTimeout(() => {
          setCount(false);
        }, 120 * 1000);
      } catch (e) {
        // tat camera co loi
        setRefresh(!refresh);
        setIsLoading(false);
        if (e.response.status === 403) {
          Toast.open(
            t(
              "settingCam.You_do_not_have_permission_to_turn_the_camera_on_or_off"
            ),
            "danger"
          );
        } else if (e.response.status === 404) {
          setIsLoseConnect(true);
        } else {
          Toast.open(e.response?.data?.result, "danger");
        }
      }
    } else {
      if (checkTime(camera[0].CODE)) {
        try {
          console.log(setting);
          
          // bat camera
          const codeCamera = camera[0].CODE;
          const data = {
            camera_id: codeCamera,
            source_stream: setting.sourceConfig,
            codec_stream: setting.streamMode,
            stream_protocol: setting.protocol,
          };
          if (camera[0].STATUS_ACTIVE !== 0) {
            await cameraManagement.startStreaming(
              "streamManagement/post-start-streaming/",
              data
            );
            // await recordApi.updateRestream({
            //   camera_id: codeCamera,
            //   codec_stream: setting.streamMode,
            //   source_stream: setting.sourceConfig,
            // });
          } else {
                        
            await recordApi.updateRestream({
              camera_id: codeCamera,
              codec_stream: setting.streamMode,
              source_stream: setting.sourceConfig,
              stream_protocol: setting.protocol,
            });
          }
          const res2 = await cameraManagement.update(
            {
              camera_status: "On",
              // stream_mode: setting.streamMode,
            },
            codeCamera
          );

          handleChangePriorityCamera(codeCamera, 1);
          setIsLoading(false);
          if (res2.result) {
            Toast.open(
              t("settingCam.Camera_turned_on_successfully"),
              "success"
            );
            setIsRefresh(!isRefresh);
          }
          setTimeout(() => {
            getListStatus(codeCamera);
          }, 30 * 1000);
          setCount(true);
          setTimeout(() => {
            setCount(false);
          }, 120 * 1000);
        } catch (e) {
          // bat camera co loi
         
          
          setIsLoading(false);
          setRefresh(!refresh);
          if (e?.response?.status === 403) {
            Toast.open(
              t(
                "settingCam.You_do_not_have_permission_to_turn_the_camera_on_or_off"
              ),
              "danger"
            );
          } else if (e.response?.status === 404) {
            setIsLoseConnect(true);
          } else if (e.response?.status === 500) {
            Toast.open(t("cameraManager.Error_from_server_side"), "danger");
          } else {
            Toast.open(e.response?.data?.result, "danger");
          }
        }
      } else {
        Toast.open(
          t(
            "settingCam.The_operation_is_too_fast_Wait_a_few_minutes_to_continue_performing_the_operation"
          ),
          "danger"
        );
      }
    }
  };
  const handleSetDefault = async (code) => {
    setIsLoading(true);
    try {
      const res = await recordApi.setDefaultConfig(code);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      if (e.response.status === 403) {
        Toast.open(
          t(
            "settingCam.You_do_not_have_permission_to_turn_the_camera_on_or_off"
          ),
          "danger"
        );
      } else if (e.response.status === 404) {
        setIsLoseConnect(true);
      } else if (e.response.status === 500) {
        Toast.open(t("cameraManager.Error_from_server_side"), "danger");
      } else {
        Toast.open(e.response?.data?.result, "danger");
      }
    }
  };
  const handleUpdateRecord = async (
    code,
    day,
    defaultCf,
    boolean,
    timeKeeping,
    status,
    timeKeepingAI,
    quality,
    codec
  ) => {
    setIsLoading(true);
    try {
      if (status === "On") {
        const record = {
          camera_code: code,
          status_record: boolean ? "1" : "0",
          source_recommend: quality,
          codec: codec,
          // fps_record: fps,
        };
        const res1 = await recordApi.changeStatus(record);
        await recordApi.updateRestream({
          camera_id: code,
          codec_record: codec,
          // codec_stream: setting.streamMode,
          source_record: quality,
          // source_stream: setting.sourceConfig,
        });
      } else {
      }

      if (day !== timeKeeping && day <= timeKeeping) {
        const res = await recordApi.configRecord({
          camera_id: code,
          time_keeping: day,
        });
      }

      if (type != "3") {
        await aiConfigService.configAi({
          cameraid: code,
          time_keeping: timeKeepingAI,
        });
      }
      Toast.open(t("cameraManager.Update_record_successfully"), "success");
      setIsLoading(false);
      setIsRefresh(!isRefresh);
      setCount(true);
      setTimeout(() => {
        setCount(false);
      }, 120 * 1000);
      // getCount();
    } catch (e) {
      setIsLoading(false);
      if (e.response?.status === 403) {
        Toast.open(
          t(
            "settingCam.You_do_not_have_permission_to_turn_the_camera_on_or_off"
          ),
          "danger"
        );
      } else if (e.response?.status === 404) {
        setIsLoseConnect(true);
      } else {
        Toast.open(t("infoCamera.updateError"), "danger");
      }
    }
  };
  const handleCloseOnSave = () => {
    dispatch(actions.reGetNotification());
    handleClose();
  };

  React.useEffect(() => {
    const handleClickOutSide = (e) => {
      if (e.target === refModal.current) {
        handleClose();
      }
    };
    document.body.addEventListener("click", handleClickOutSide);
    return () => {
      document.body.addEventListener("click", handleClickOutSide);
    };
    // eslint-disable-next-line
  }, []);

  const handleChangePriorityCamera = async (code, status) => {
    try {
      await axiosClient.put("/camerainfo/put-set-status-camera-priority/", {
        list_cam: {
          data: [
            {
              camera_code: code,
              status_priority: status,
            },
          ],
        },
      });
    } catch (error) {
      throw new Error("We can't update priority");
    }
  };

  useEffect(() => {
    const getListCameraAI = async () => {
      try {
        const param = {
          camera_code: camera[0]?.CODE,
        };
        const res = await serviceApi.getListServiceRegistered(param);
        if (res.length > 0) {
          const listService = res.map((item) => {
            return {
              key: item.CODE,
              name:
                listAiTranslate.find((ai) => ai.ai_name === item.SUBJECT_NAME)
                  ?.name_tr || item.SUBJECT_NAME,
            };
          });
          setListServiceAI(listService);
        }
      } catch (e) {
        if (e.response?.status === 403) {
          Toast.open(
            t("settingCam.You_do_not_have_permission_to_use_AI"),
            "danger"
          );
        } else if (e.response.status === 500) {
          Toast.open(t("cameraManager.Error_from_server_side"), "danger");
        } else {
          Toast.open(e.response?.data?.result, "danger");
        }
      }
    };
    getListCameraAI();
  }, [listAiTranslate, camera]);
  return (
    <>
      {isLoseConnect && (
        <Alert
          title={t(
            count
              ? "settingCam.The_system_is_processing_please_try_again_later"
              : "Tắt xem trực tiếp trước khi chỉnh sửa cấu hình"
          )}
          onClose={() => {
            setIsLoseConnect(!isLoseConnect);
          }}
          onOk={() => {
            setIsLoseConnect(!isLoseConnect);
          }}
        />
      )}
      <div
        className={cx(!fullScreen ? "modal-info" : "full-height")}
        ref={refModal}
      >
        <div className={cx(!fullScreen ? "container-setting" : "full-height")}>
          <HeaderModal
            title={`${t("stream.settingCamera")} ${
              camera.length > 0 && camera[0].NAME_CAM
            }`}
            onClose={onclose}
          />
          <div className={cx("main")}>
            <SideBar
              type={type}
              onChange={onChangeType}
              listServiceAI={listServiceAI}
              typeCamera={typeCamera}
            />
            <Setting
              setType={setTypeCamera}
              onChange={onChange}
              onRecord={record}
              show={show}
              type={type}
              camera={camera}
              onClose={handleCloseOnSave}
              changeConfigRecord={changeConfigRecord}
              listServiceAI={listServiceAI}
              updateRecord={handleUpdateRecord}
              setDefault={handleSetDefault}
              isLoading={isLoading}
              setIsSetting={setIsSetting}
            />
            {isLoading && (
              <div className={cx("loading-modal")}>
                <Loading />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalSetting;
